// src/graphql/common_holdings.js
import { gql } from "@apollo/client";

/**
 * Common Holdings Query
 * 
 * Removed quantity fields (no longer available).
 * Now uses only value-based aggregation.
 */
const COMMON_HOLDINGS = gql`
  query GetCommonHoldings(
    $holdingMonth: String!
    $holdingYear: String!
    $category: String
    $limit: Int = 50
  ) {
    getCommonHoldings(
      holdingMonth: $holdingMonth
      holdingYear: $holdingYear
      category: $category
      limit: $limit
    ) {
      stockName
      stockSector
      totalValueInMn
      fundCount
      funds {
        mutualFundId
        mutualFundName
        valueInMn
        percentageOfTotalHoldings
      }
    }
  }
`;

export default COMMON_HOLDINGS;
